<template>
  <div id="app">
    <router-view/>
    <div v-if="isshowback" class="goback" @click="goback"></div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      isshowback:false
    }
  },
  created:function(){
    //this.isshowback = location.pathname != "/";
  },
  methods:{
    goback:function(){
      let that = this;
      if(location.pathname != "/wechat/home"){
        that.$router.go(-1);
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue